import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { debounce, isEmpty } from 'lodash';

import moment from 'moment';

import BobFilterComponent from '../../../components/BobFilterComponent';
import HealthMonitorTable from '../HealthMonitorTable/HealthMonitorTable';
import TotalsPanel from '../../../components/TotalsPanel';
import RuleTotalsPanel from '../../../components/RuleTotalsPanel';
import FaultsPanel from './FaultsPanel';
import RulesPanel from './RulesPanel';
import SensorPanel from './SensorPanel';
import EquipmentPanel from './EquipmentPanel';
import BobActionMenu from '../../../components/BobActionMenu';
import BobModal from '../../../components/BobModal';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import SearchInput from '../../Global/SearchInput';
import FilterChip from '../../../components/FilterChip';
import TimeFrameSelector from '../../../components/TimeFrameSelector';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';

import TabViewSelector from '../../../components/TabViewSelector';
import ExportDataModal from '../Modals/ExportDataModal';

import { getTimeZoneAbbr } from '../../../helpers/timezones';
import { getActiveTabName } from '../Navigation/NavigationHelper';

import queryString from 'query-string';

import { withRouter } from 'react-router-dom';

import { dashboardContent } from '../../../localization/en-us/dashboardContent';

import * as BobActions from '../../../actions/bobActions';
import * as ConfigurationActions from '../../../actions/configurationActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import {
    renderChip,
    renderFilter,
    removeFilter
} from '../../../helpers/tableContainerHelper';

import classes from './TableContainer.module.css';
import { setPageTitle } from '../../../helpers/auth';

const TABNAMES = {
    'Equipment': dashboardContent.equipment,
    'Sensors':   dashboardContent.sensors,
    'Faults':    dashboardContent.faults,
    'Rules':     dashboardContent.rules
};

const TableContainer = ({
    activeNavClient,
    activeTab,
    allSensors,
    activeNavEquipment,
    allSensorsMeta,
    axes,
    cardScores,
    companyInfo,
    clearEntitySensorData,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    dashboardIsCurrentTimeStamp,
    desiredInterval,
    exportTableData,
    fetchBulkEntitySensorData,
    fetchEntitySensorData,
    fetchEntitySensors,
    systemTabIndex,
    history,
    healthMonitorFilters,
    issueTypes,
    isShowExportModal,
    refreshTab,
    setRefreshTab,
    selectedSensors,
    setAxes,
    setActiveTab,
    setDashboardEndTimestamp,
    setDashboardStartTimestamp,
    setHealthMonitorFilters,
    setSelectedSensors,
    setSensorConfiguration,
    setWorkBookMode,
    system,
    updateTimeStamp,
    selectedRule,
    workbookModeEnabled,
    ...props
}) => {
    const [deleteSensorModalOpen, handleToggleDeleteSensorModal] = useState(false);
    const [subscribeToAlertsEqquipmentModalOpen, handleToggleSubscribeToEquipmentAlertsModal] = useState(false);
    const [subscribeToRuleAlertsModalOpen, setSubscribeToRuleAlertsModalOpen] = useState(false);

    const [queryValues, setQueryValues] = useState(queryString.parse(history.location.search));

    const [searchTerm, setSearchTerm] = useState('');
    const [exportColumns, setExportColumns] = useState([]);
    const _export = React.useRef(null);

    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [isexportNodeHealthChecks, setIsexportNodeHealthChecks] = useState(false);
    const [refreshRawDataGrid, setRefreshRawDataGrid] = useState(false);

    useEffect(() => {
        if (system) {
            setPageTitle(system.name, activeTab);
        }
    }, [system]);

    useEffect(() => {
        const { pathname } = history.location;
        const queryValues = queryString.parse(history.location.search);
        
        let key = queryValues.appId;
            
        if ( queryValues.parentId ) {
            key = queryValues.parentId;
        }

        if ( queryValues.childId ) {
            key = queryValues.childId;
        }

        let activetab = getActiveTabName(key);
        if (system) {
            setPageTitle(system.name, activetab);
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValuesString}`);
        setSearchTerm('');
        setTimeout(() => {
            setActiveTab(activetab);
        }, 100);
    }, [history.location.search]);

    useEffect(() => {
        setQueryValues(queryString.parse(history.location.search));
    }, [history.location.search]);

    useEffect(() => {
        setSensorConfiguration({});
        clearEntitySensorData();
        setSelectedSensors([]);
    }, [queryValues.system]);

    const handleExport = event => {
        setExportModalOpen(true);
    };

    const handleCreateSensor = () => {
        history.push('/v2/dashboard/system/sensor' + history.location.search);
    };

    const handleCalculatedSensor = () => {
        history.push({ pathname: '/v2/dashboard/calculated/sensor', search: history.location.search, state: { entityId: activeNavEquipment.id, sensorHistory: [...selectedSensors], ruleHistory: selectedRule, entityType: 'system' } });
    };

    const handleChangetabView = (tabView) => {
        const queryValues = queryString.parse(history.location.search);
        let childId = '';

        const { pathname } = history.location;

        if ( tabView.viewParentId ) {
            childId = tabView.viewParentId;
            let viewChildId = tabView.key;

            queryValues.childId = childId;
            queryValues.viewChildId = viewChildId;
        } else {
            if (tabView.key === '383849dd-bd20-4ee2-a0e5-1b192ddc4f81') {
                childId = '4b25aeb8-77d4-4522-9f77-870ab40abb02';
                queryValues.childId = tabView.key;
                queryValues.viewChildId = childId;
            }
            else {
                childId = tabView.key;
                queryValues.childId = childId;
            }
            
        }
        
        const queryValueString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValueString}`);
    };

    const handleHealthMonitorExport = event => {
        const statusColumn = exportColumns.findIndex(c => c.field === 'status');
        const priorityColumn = exportColumns.findIndex(c => c.field === 'priority');
        const issueTypeColumn = exportColumns.findIndex(c => c.field === 'issueTypes');
        const equipmentSystemColumn = exportColumns.findIndex(c => c.field === 'equipmentSystem');
        const routeColumn = exportColumns.findIndex(c => c.field === 'snapshotRoute');
        const faultTimestampColumn = exportColumns.findIndex(c => c.field === 'faulttimestamp');
        const options = _export.current.workbookOptions();
        const rows = options.sheets[0].rows;
        rows.forEach(row => {
            if (row.type === 'data') {
                const statusCell = row.cells[statusColumn];
                const priorityCell = row.cells[priorityColumn];
                const issueTypeCell = row.cells[issueTypeColumn];
                const routeCell = row.cells[routeColumn];
                const equipmentSystemCell = row.cells[equipmentSystemColumn];
                const faultTimestampCell = row.cells[faultTimestampColumn];
                equipmentSystemCell.value = routeCell.value.substring(routeCell.value.lastIndexOf('/') + 1);
                statusCell.value = statusCell.value.toString().toLowerCase() === 'true' ? 'Fault' : 'OK';
                priorityCell.value = priorityCell.value === 0 ? 'Low' : priorityCell.value === 1 ? 'Medium' : 'High';
                issueTypeCell.value = issueTypeCell.value.join(', ');
                faultTimestampCell.value = faultTimestampCell.value ? moment(faultTimestampCell.value).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(faultTimestampCell.value), moment.tz.guess()) : null;
            }
        });
        _export.current.save(options);
    };

    const healthMonitorRawDataExport = event => {
        setIsexportNodeHealthChecks(true);
    };
    
    const handleSearch = async searchTerm => {
        setSearchTerm(searchTerm);
    };
    
    const refreshGrid = () => {
        setRefreshTab(activeTab);
    };

    const activeFilters = {
        'Health Monitor': healthMonitorFilters
    };

    const renderChips = activeTab => {
        let filters = activeFilters[activeTab] || {};

        if (isEmpty(filters)) return [];

        return renderChip(filters);
    };

    const renderSelectData = activeTab => {
        switch (activeTab) {
            case 'Health Monitor':
                return issueTypes;
            default:
                return [];
        }
    };

    const handleRemoveFilter = (activeTab, item) => {
        const setFilters = selectSetFilter(activeTab);
        let filters = activeFilters[activeTab];

        removeFilter(setFilters, filters, item);
    };

    const renderLabel = activeTab => {
        // Both case 2 (equipment) and case 3 (system) use
        // equipment type to describe the entity.
        switch (activeTab) {
            case 'Health Monitor':
                return 'Issue Types';
            default:
                return '';
        }
    };

    const renderActiveFilters = activeTab => {
        let filters = activeFilters[activeTab] || {};

        return renderFilter(filters);
    };

    const handleSetFilter = activeTab => {
        return selectSetFilter(activeTab);
    };

    const selectSetFilter = activeTab => {
        switch (activeTab) {
            case 'Health Monitor':
                return setHealthMonitorFilters;
            default:
                return;
        }
    };

    const getTimeZone = () => {
        const zone = moment.tz.guess();
        const time = moment(new Date());
        const timeZone = getTimeZoneAbbr(moment(time), zone);

        return timeZone;
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    return (
        <div className={classes.TableContainer}>
            { activeTab === 'Faults' || activeTab === 'Rules' || activeTab === 'Equipment' || activeTab === 'Health Monitor' ?
                <div className={classes.SelectContainer}>
                    <TabViewSelector
                        overviewPage={'system'}
                        activeTab={activeTab}
                        handleChangeView={handleChangetabView}
                    />
                </div>
                : null
            }
            { activeTab === 'Health Monitor' ?
                <div className={classes.SearchContainer}>
                    <SearchInput
                        key={new Date()}
                        className={classes.SearchInput}
                        search={debounce(handleSearch, 700)}
                        placeholder={`Search by ${activeTab === 'Health Monitor' ? 'Rule' : activeTab} Name`}
                        value={searchTerm}
                    />
                </div>
                : null}
            {
                activeTab === 'Faults' || activeTab === 'Equipment' ?
                    <div className={classes.WorkbookModeContainer}>
                        <BobWorkbookModeButton
                            handleWorkbookMode={handleWorkbookMode}
                            workbookMode={workbookModeEnabled}
                        />
                    </div>
                    :
                    null
            }
            {
                activeTab === 'Faults' ?
                    <div className={classes.TimeFrameSelector}>
                        <TimeFrameSelector
                            dashboardEndTimeStamp={dashboardEndTimeStamp.format()}
                            dashboardStartTimeStamp={dashboardStartTimeStamp.format()}
                            isCurrent={dashboardIsCurrentTimeStamp}
                        />
                    </div>
                    :
                    null
            }
            {
                activeTab === 'Faults' ?
                    <div className={classes.TimezoneContainer}>
                        <label className={classes.IntervalLabel}>{`Timezone - ${getTimeZone()}`}</label>
                    </div>
                    :
                    null
            }
            { activeTab === 'Rules' || activeTab === 'Equipment' ?
                <div className={classes.DesiredIntervalContainer}>
                    <label className={classes.IntervalLabel}>{`Interval - ${desiredInterval}`}</label>
                </div> 
                :
                null
            }
            { activeTab === 'Faults' || activeTab === 'Rules' || activeTab === 'Equipment' ?
                <div className={classes.DataContainer}>
                    <RuleTotalsPanel />
                </div>
                :
                null
            }
            {
                activeTab === 'Sensors' ?
                    null:
                    <div
                        className={classes.RefreshContainer}
                        aria-hidden="true"
                        role="button"
                        tabIndex={0}
                        onClick={refreshGrid}
                    >
                        <span className="material-icons-outlined">refresh</span>
                    </div>
            }
            {
                activeTab === 'Health Monitor' ?
                    <div className={classes.DataContainer}>
                        <TotalsPanel
                            data={cardScores}
                            entityType={`Health Monitors`}
                        />
                    </div>
                    :
                    null
            }
            { activeTab === 'Faults' || activeTab === 'Equipment' ?
                <div className={classes.ActionButtonContainer}>
                    <BobActionMenu
                        activeTab={`System${TABNAMES[activeTab]}`}
                        isExport={true}
                        handleExport={handleExport}
                        handleCreateSensor={() => handleCreateSensor()}
                        handleCalculatedSensor={() => handleCalculatedSensor()}
                        handleCreateSubscription={(value) => handleToggleSubscribeToEquipmentAlertsModal(value)}
                    />
                </div>
                :
                activeTab === 'Health Monitor' ?
                    <div className={classes.ActionButtonContainer}>
                        <BobActionMenu
                            isExport={false}
                            handleHealthMonitorExport={handleHealthMonitorExport}
                            isHealthMonitor={true}
                            healthMonitorRawDataExport={healthMonitorRawDataExport}
                        />
                    </div>
                    :
                    null
            }
            {
                activeTab !== 'Health Monitor' ?
                    null :
                    process.env.dashboardFilteringEnabled ?
                        <div className={classes.FilterContainer}>
                            {renderChips(activeTab).map((item, index) => (
                                <FilterChip
                                    key={index}
                                    item={item}
                                    removeFilter={() => handleRemoveFilter(activeTab, item)}
                                />
                            ))}
                            <BobFilterComponent
                                data={renderSelectData(activeTab)}
                                label={renderLabel(activeTab)}
                                filterType={TABNAMES[activeTab]}
                                activeFilters={renderActiveFilters(activeTab)}
                                setFilters={handleSetFilter(activeTab)}
                                showStatusFilter={ activeTab === 'Health Monitor' ? true : false}
                            />
                        </div>
                        :
                        null
            }
            <div className={classes.GridContainer}>
                {
                    activeTab === 'Sensors' ?
                        <SensorPanel
                            activeTab={activeTab}
                            axes={axes}
                            deleteSensorModalOpen={deleteSensorModalOpen}
                            handleToggleDeleteSensorModal={(value) => handleToggleDeleteSensorModal(value)}
                            handleToggleSubscribeToEquipmentAlertsModal={(value) => handleToggleSubscribeToEquipmentAlertsModal(value)}
                            isActive={true}
                            refreshRawDataGrid={refreshRawDataGrid}
                            refreshTab={refreshTab}
                            setAxes={setAxes}
                            setRefreshRawDataGrid={setRefreshRawDataGrid}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            system={system}
                            updateTimeStamp={updateTimeStamp}
                        />
                        : null
                }
                {
                    activeTab === 'Faults' ?
                        <FaultsPanel
                            isActive={true}
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        : null
                }
                {
                    activeTab === 'Rules' ?
                        <RulesPanel
                            isActive={true}
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                        />
                        : null
                }
                {
                    activeTab === 'Equipment' ?
                        <EquipmentPanel
                            searchTerm={searchTerm}
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                        />
                        : null
                }
                {
                    activeTab === 'Health Monitor' ?
                        <HealthMonitorTable
                            node={{ type: 'systemItem', id: queryValues.system }}
                            searchTerm={searchTerm}
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            healthMonitorFilters={healthMonitorFilters}
                            exportRef={_export}
                            setExportColumns={setExportColumns}
                            exportColumns={exportColumns}
                            setIsexportNodeHealthChecks={setIsexportNodeHealthChecks}
                            isexportNodeHealthChecks={isexportNodeHealthChecks}
                            subscribeToRuleAlertsModalOpen={subscribeToRuleAlertsModalOpen}
                            setSubscribeToRuleAlertsModalOpen={(value) => setSubscribeToRuleAlertsModalOpen(value)}
                        />
                        :
                        null
                }

            </div>
            {
                subscribeToAlertsEqquipmentModalOpen ?
                    <CreateSubscriptionModal
                        parent={{ ...system, clientId: activeNavClient.id }}
                        parentLabel="System"
                        handleToggleSubscribeToAlertsModal={handleToggleSubscribeToEquipmentAlertsModal}
                    />
                    :
                    null
            }
            { isShowExportModal ?
                <BobModal
                    title={''}
                    isOnlyContent={true}
                >
                    <h3>Preparing Export</h3>
                </BobModal> : ''
            }
            {
                exportModalOpen ?
                    <ExportDataModal
                        entity={system}
                        setExportModalOpen={setExportModalOpen} 
                        tabView={`System${TABNAMES[activeTab]}`}
                    /> : ''
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavClient:             state.bob.activeNavClient,
        allSensors:                  state.bob.allSensors,
        allSensorsMeta:              state.bob.allSensorsMeta,
        cardScores:                  state.home.cardScores,
        companyInfo:                 state.companyInfo,
        dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp,
        desiredInterval:             state.dashboard.desiredInterval,
        healthMonitorFilters:        state.dashboard.healthMonitorFilters,
        isShowExportModal:           state.dashboard.isShowExportModal,
        issueTypes:                  state.svcManagement.issueTypes,
        selectedSensors:             state.dashboard.selectedSensors,
        systemTabIndex:              state.dashboard.systemTabIndex,
        selectedRule:                state.dashboard.selectedRule,
        workbookModeEnabled:         state.dashboard.workbookModeEnabled,
        activeNavEquipment:          state.bob.activeNavEquipment
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...ConfigurationActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableContainer));
